import type { Client } from '@frontend/api-types';

export const useLowCreditBonusBanner = (client?: Client) => {
  const shouldShowBanner = client?.isEligibleForLowCreditBonus ?? false;

  return { shouldShowBanner };
};
